import React from "react";
import { css } from "@emotion/react";
import HashLoader from "react-spinners/HashLoader";

const override = css`
  margin: auto;
  display: block;
`;
function ActivityIndicator() {
  return (
    <>
      <div>
        <span style={{display: "block"}}> { /* Color #34359A or #2d5971 */}
          <HashLoader color={"#2d5971"} size={50} />
        </span>
      </div>
    </>
  );
}
export default ActivityIndicator;
